import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { getTipoAplicacao } from "../../services/api_tipo_aplicacao";
import { getEmpresas } from "../../services/api_base";
import { getEmpresaById } from "../../services/api_cadastros_empresas";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { id } from "date-fns/locale";

const RelatorioForm = ({
  show,
  handleClose,
  handleGenerate,
  setFiltro,
  setShowForm,
  setShowRelatorio,
}) => {
  const [empresa, setEmpresa] = useState("");
  const [nomeEmpresa, setNomeEmpresa] = useState("");
  const [unidade, setUnidade] = useState("");
  const [nomeUnidade, setNomeUnidade] = useState("");
  const [tipoAplicacao, setTipoAplicacao] = useState("");
  const [descricaoTipoAplicacao, setDescricaoTipoAplicacao] = useState("");
  const [garantia, setGarantia] = useState("");
  const [unidadesListagem, setUnidadesListagem] = useState([]);
  const [tiposAplicacaoListagem, setTiposAplicacaoListagem] = useState([]);
  const [empresasListagem, setEmpresasListagem] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [showMessage, setShowMessage] = useState(true)
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmpresas = () => {
      Swal.fire({
        title: "Carregando dados...",
        didOpen: async () => {
          Swal.showLoading();
          try {
            const response = await getEmpresas();
            //console.log("informações empresas", response);

            if (response && response.status === 200) {
              const empresasAtivas = response.data.empresas.filter(
                (empresa) => empresa.deleted_at == null
              );
              setEmpresasListagem(empresasAtivas);
              setLoading(false)
              Swal.close();
            } else {
              return Swal.fire({
                icon: "error",
                title: "Erro interno",
                text: "Não foi possível carregar os dados necessários para gerar relatórios. Tente novamente mais tarde.",
                confirmButtonText: "Tentar novamente",
                preConfirm: fetchEmpresas(),
              });
            }
            //console.log(response);
          } catch (error) {
            console.error("Erro ao obter empresas:", error);
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
    };

    fetchEmpresas();
  }, []);

  useEffect(() => {
    const fetchTipoAplicacao = async () => {
      try {
        const response = await getTipoAplicacao();
        //console.log("informações tipo aplicação", response);

        if (response) {
          const tiposAplicacaoAtivos = response.data.TiposAplicacao.filter(
            (tipoAplicacao) => tipoAplicacao.deleted_at == null
          );
          setTiposAplicacaoListagem(tiposAplicacaoAtivos);
          setLoading(false);
        } else {
          console.error("Algo deu errado:");
        }
        //console.log(response);
      } catch (error) {
        console.error("Erro ao obter empresas:", error);
      }
    };

    fetchTipoAplicacao();
  }, []);

  const handleUnidadesEmpresa = async (idEmpresa) => {
    if(!idEmpresa) {
      setUnidadesListagem([])
      setShowMessage(false)
      setShowMessage(false)
      return;
    }
    Swal.fire({
      title: "Carregando unidades da empresa",
      didOpen: async () => {
        Swal.showLoading();
        try {
          const response = await getEmpresaById(idEmpresa);
          if (response.status === 200) {
            const unidadesAtivas = response.data.empresa.unidades.filter(
              (unidade) => unidade.deleted_at == null
            );
            setUnidadesListagem(unidadesAtivas);
            Swal.close();
          }
        } catch (error) {
          //console.log(error);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  };

  const handleGenerateRelatorio = () => {
    if (!empresa) {
      return Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "É necessário informar a empresa.",
      });
    }
    try {
      handleGenerate({
        empresa,
        unidade,
        tipoAplicacao,
        nomeEmpresa,
        nomeUnidade,
        descricaoTipoAplicacao,
        garantia,
      });
      handleClose();
    } catch (error) {
      console.error("Erro ao gerar relatório:", error);
    }
  };

  const handleGoHome = () => {
    navigate("/home");
  };

  const handleClearClick = () => {
    setEmpresa("");
    setUnidade("");
    setNomeEmpresa("");       
    setNomeUnidade(""); 
    setDescricaoTipoAplicacao(""); 
    setGarantia("")
  };

  return (
    <Modal 
      show={show} 
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton onHide={handleGoHome}>
        <Modal.Title>Gerar Relatório</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formUnidade">
            <Form.Label>Empresa</Form.Label>
            <Form.Control
              as="select"
              value={empresa}
              onChange={(e) => {
                setEmpresa(e.target.value);
                handleUnidadesEmpresa(e.target.value);
                setShowMessage(false)
                setNomeEmpresa(
                  e.target.options[e.target.selectedIndex].getAttribute(
                    "data-nome"
                  )
                );

                //console.log(nomeEmpresa);
              }}
              required
            >
              <option value="">Selecione</option>
              {empresasListagem &&
                empresasListagem.map((empresa) => (
                  <option
                    key={empresa.id}
                    value={empresa.id}
                    data-nome={empresa.nome}
                  >
                    {empresa.nome}
                  </option>
                ))}
            </Form.Control>
            {showMessage && !empresa && (
            <small className="form-text text-danger">
              Escolha uma empresa
            </small>
          )}
          </Form.Group>
          <Form.Group controlId="formUnidade">
            <Form.Label>Unidade</Form.Label>
            <Form.Control
              as="select"
              value={unidade}
              disabled={!empresa ? true : false}
              onChange={(e) => {
                setUnidade(e.target.value);
                setNomeUnidade(
                  e.target.options[e.target.selectedIndex].getAttribute(
                    "data-nome"
                  )
                );
                //console.log(nomeUnidade);
              }}
            >
              <option value="">Selecione</option>
              {unidadesListagem &&
                unidadesListagem.map((unidade, index) => (
                  <option
                    key={index}
                    value={unidade.id}
                    data-nome={unidade.nome}
                  >
                    {unidade.nome}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="formTipoAplicacao">
            <Form.Label>Tipo de Aplicação</Form.Label>
            <Form.Control
              as="select"
              value={tipoAplicacao.id}
              onChange={(e) => {
                setTipoAplicacao(e.target.value);
                setDescricaoTipoAplicacao(
                  e.target.options[e.target.selectedIndex].getAttribute(
                    "data-descricao"
                  )
                );
              }}
              required
            >
              <option value="">Selecione</option>
              {tiposAplicacaoListagem &&
                tiposAplicacaoListagem.map((tipoAplicacao, index) => (
                  <option
                    key={index}
                    value={tipoAplicacao.id}
                    data-descricao={tipoAplicacao.descricao}
                  >
                    {tipoAplicacao.descricao}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="garantia">
            <Form.Label>Garantia</Form.Label>
            <Form.Control
              as="select"
              value={garantia}
              onChange={(e) => {
                setGarantia(e.target.value);
                //console.log(e.target.value);
              }}
            >
              <option value="">Selecione</option>
              <option value="Em garantia">Em garantia</option>
              <option value="Sem garantia">Garantia expirada</option>
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Link to={`/home`}>
          <button className="btn btn-light text-dark">
            <FontAwesomeIcon icon={faHome} size="1x" color= 'gray' />
          </button>
        </Link>
        <Button 
          variant={!empresa ? "secondary" : "primary"}
          onClick={handleGenerateRelatorio}
          disabled={!empresa}
        >
          Gerar
        </Button>
        <Button variant="danger" onClick={handleClearClick}>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RelatorioForm;
